import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import ThemeMenuThree from '../../../components/header/ThemeMenuThree'
import PageTitle from '../../../components/page-title/PageTitle'
import FooterThree from '../../../components/footer/FooterThree'

const practices = [
    {
        title: '비동기 우선',
        desc: '가능한 맥락을 문서·티켓·채널에 남기고, 회의는 합의와 의사결정이 필요할 때만 잡습니다.',
    },
    {
        title: '리뷰와 표준',
        desc: '코드·설계·체크리스트로 품질 기준을 맞추고, 경험이 적은 구성원도 같은 바를 밟을 수 있게 합니다.',
    },
    {
        title: '고객과의 동행',
        desc: '납기만 쫓기보다 리스크와 우선순위를 함께 정리하고, 중간 산출물로 방향을 자주 맞춥니다.',
    },
    {
        title: '측정 가능한 약속',
        desc: '말로만 하는 확답 대신 범위·가정·검증 방법을 적어 두고, 바뀌면 즉시 공유합니다.',
    },
]

const rhythms = [
    {
        title: '일상',
        items: ['데일리·스탠드업은 팀 단위로 짧게', '블로커는 당일 공유', '집중 시간 존중'],
    },
    {
        title: '주간',
        items: ['스프린트·마일스톤 점검', '리스크·의존성 정리', '고객 공유용 요약 정리'],
    },
    {
        title: '분기',
        items: ['기술 부채·도구 개선 백로그', '교육·컨퍼런스 등 성장 계획', '내부 회고'],
    },
]

const HowWeWork = () => {
    const heroImg = `${process.env.PUBLIC_URL}/assets/img/about/work_img_3.png`

    return (
        <Fragment>
            <div className="main-page-wrapper">
                <ThemeMenuThree />
                <PageTitle title="우리가 일하는 방식" parentTo="/about" parentLabel="코담 소개" />

                <section className="codam-feature pt-120 pt-lg-70 pb-35 pb-lg-20">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-lg-7">
                                <div className="section-title-two mb-25">
                                    <h6 className="sub-title mb-20">How we work</h6>
                                    <h2 className="sect-title">{'약속을 지키기 위한 일하는 법'}</h2>
                                </div>
                                <p className="mb-25">
                                    {
                                        '엔터프라이즈 프로젝트는 이해관계자가 많고 요구가 자주 바뀝니다. '
                                    }
                                    {
                                        '그래서 코담은 개인의 영웅심보다 재현 가능한 프로세스와 투명한 소통을 우선합니다.'
                                    }
                                </p>
                                <Link className="theme_btn me-3 mb-15" to="/core-values">
                                    핵심 가치
                                </Link>
                                <Link className="theme_btn border-btn mb-15" to="/recruit">
                                    채용
                                </Link>
                            </div>
                            <div className="col-lg-5">
                                <div className="about-img-wrapper-four codam-prepaid-hero-visual position-relative mt-35 mt-lg-0 text-center">
                                    <img className="main-img w-100" src={heroImg} alt="코담 협업과 납품" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="counter-area codam-core-values pt-70 pb-60 pt-lg-30 pb-lg-30">
                    <div className="container">
                        <div className="section-title-two text-center mb-40">
                            <h6 className="sub-title mb-20">원칙</h6>
                            <h2 className="sect-title">{'실무에서 반복하는 네 가지'}</h2>
                        </div>
                        <div className="row gx-4 gx-xxl-5">
                            {practices.map((item) => (
                                <div key={item.title} className="col-md-6 col-xl-3 mb-30">
                                    <div className="feature-style-one h-100 mb-0">
                                        <h2 className="mb-15" style={{ fontSize: 'clamp(22px, 2vw, 28px)' }}>
                                            {item.title}
                                        </h2>
                                        <p className="mb-0">{item.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="about-codam codam-prepaid-steps pt-20 pb-90 pt-lg-20 pb-lg-50">
                    <div className="container">
                        <div className="section-title-two text-center mb-45">
                            <h6 className="sub-title mb-20">리듬</h6>
                            <h2 className="sect-title">{'시간 단위로 나눈 협업'}</h2>
                            <p className="mt-20 mb-0">
                                {'프로젝트 성격에 따라 조정되지만, 아래는 많은 팀이 공통으로 가져가는 틀입니다.'}
                            </p>
                        </div>
                        <div className="row gx-4 gx-xxl-5">
                            {rhythms.map((block, idx) => (
                                <div key={block.title} className="col-lg-4 mb-30">
                                    <div className="feature-style-two h-100 mb-0 p-4">
                                        <div className="codam-prepaid-steps__node mb-20 d-inline-flex">{idx + 1}</div>
                                        <h5 className="mb-20">{block.title}</h5>
                                        <ul className="list-none ps-0 mb-0">
                                            {block.items.map((line) => (
                                                <li key={line} className="mb-12 text-white opacity-90">
                                                    {line}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="codam-feature pb-120 pb-lg-70">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xl-9 col-lg-10">
                                <div className="section-title-two text-center mb-35">
                                    <h6 className="sub-title mb-20">더 보기</h6>
                                    <h2 className="sect-title">{'가치·사람·채용으로 이어집니다'}</h2>
                                    <p className="mt-20 mb-0">
                                        {
                                            '일하는 방식은 핵심 가치의 실천이고, 함께할 크루를 찾을 때도 같은 기준을 씁니다.'
                                        }
                                    </p>
                                </div>
                                <div className="text-center">
                                    <Link className="theme_btn me-3 mb-15" to="/about">
                                        코담 소개
                                    </Link>
                                    <Link className="theme_btn border-btn me-3 mb-15" to="/crew-recruit">
                                        함께할 크루 모집
                                    </Link>
                                    <Link className="theme_btn border-btn mb-15" to="/contact">
                                        문의
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <FooterThree />
            </div>
        </Fragment>
    )
}

export default HowWeWork
